import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { 
    fetchAcbList, 
    AcbListResponse, 
    AcbListResults, 
    AcbListParams, 
    defaultParams 
} from "../../components/Rest/FetchACBList"
import { useState } from "react"
import { useEffect } from "react"
import { AcbTable } from "../../components/Accumulator/AcbTable"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { ElasticSearchField } from "../../components/SearchFields/SearchFields"
import { TableFilter } from "../../components/Pickers/tableFilters" 
import { Title } from "../../components/units/Text"
import { TablePaginationSelector } from "../../components/Pickers/tableFilters"
import { Divider } from "../../components/units/Divider"
import { DetailText } from "../../components/units/Text"
import { hasPermission, useValidatePermission } from "../../roles/roles"
import { useSignedInContext } from "../../context/AuthContextProvider"

type FiltersState = {
    isExploationOpen: boolean;
}


export const ACBList = () => {
    const { user } = useSignedInContext()

    const [acbList, setAcbList] = useState<AcbListResponse | undefined>(undefined)
    const [params, setTableParams] = useState<AcbListParams>(defaultParams())
    const [filterState, setFilterState] = useState<FiltersState>({isExploationOpen:false})
    const [loading, setLoading] = useState<boolean>(false)
    const [selectorIsOpen, setSelectorIsOpen] = useState<boolean>(false)

    const toggleExploatationFilter = (toggle: boolean) => {
        setFilterState((prev) => ({
            ...prev, isExploationOpen : toggle
        }))
    }

    const setPage = (value: number) => {
        setTableParams((prev) => ({
            ...prev, currentPage: value
        }))
    }

    const setSearch = (search:string):void => {
        setTableParams((prev) => ({
            ...prev, search : search
        }))
    };

    const setExploatationFilter = (value: boolean | undefined):void => {
        setTableParams((prev) => ({
            ...prev, is_manufacture_date : value
        }))
    }

    const setOrder = (value: string): void => {
        setTableParams((prev) => ({
            ...prev, ordering : value
        }))
    }

    const setLimit = (value: number): void => {
        setTableParams((prev) => ({
            ...prev, limit : value
        }))
    }

    const fetchAcbs = async () => {
        if (acbList?.results) {
            setLoading(true)
        }
        fetchAcbList(params, setAcbList, setLoading)
    }

    useEffect(() => {
        fetchAcbs()
    }, [params.currentPage, params.ordering, params.is_manufacture_date, params.limit])

    useEffect(() => {
        const dropTimeout = ():void => {
            clearTimeout(params.timeout)
            setTableParams((prev) => ({
                ...prev, timeout : undefined
            }))

        }
        if (params.search === undefined) {
            return
        }
        if (params.timeout) {
            dropTimeout()
        } 
        const timeout = setTimeout(() => {
            fetchAcbs()
            dropTimeout()
        }, 750) 
        setTableParams((prev) => ({
            ...prev, timeout : timeout
        }))
    }, [params.search])

    useEffect(() => {
        console.log(user.role)
    }, [user.role])
    return (
        <ContentWrapper>
            <Title>Список батарей</Title>
            <Divider/>
            <br />
            <BoxWrapper p="p0">
                <FlexWrapper flexWrap="nowrap">
                    <ElasticSearchField timeout={params.timeout} setSearch={setSearch} className="full-width"/>
                    { hasPermission({role: user.role, resource: 'AcbList', action: "create"}) && (
                        <DetailText href="/react/acb/mock-create"
                            color="light"
                            bg="bg-secondary"
                            className="p1 flex align-center justify-center text-no-wrap"
                            r="r15"
                            style={{height:'36px'}}
                        >Создать АКБ</DetailText>
                    )}
                </FlexWrapper>
                <br />
                <FlexWrapper justifyContent="space-between" alignItems="center">
                    <BoxWrapper p="p0" style={{width: '300px'}}>
                        <TableFilter 
                            label={"Введен в эксплуатацию: "}
                            options={[{label:'Да', value: true}, {label:'Нет', value:false}]} 
                            selected={params.is_manufacture_date}  
                            isOpen={filterState.isExploationOpen}
                            setOpen={toggleExploatationFilter}
                            dataSetter={setExploatationFilter}
                            />
                    </BoxWrapper>
                    <TablePaginationSelector
                        label={params.limit}
                        options={[{value: 10, label: '10'}, {value: 25, label: '25'}, {value: 50, label: '50'}]}
                        selected={params.limit}
                        isOpen={selectorIsOpen}
                        setOpen={setSelectorIsOpen}
                        dataSetter={(value: number) => { setLimit(value); }}
                    />
                </FlexWrapper>
            </BoxWrapper>
            <br />
            <AcbTable 
                loading={loading}
                data={acbList} 
                currentPage={params.currentPage} 
                itemsPerPage={params.limit}
                params={params}
                setter={setPage}
                orderSetter={setOrder}
                />
        </ContentWrapper>
    )
}